import styled from "styled-components";

export const SSettingsTopNavType = styled.div`
  color: var(--text-03);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 8px;
  line-height: 8px;
`;
